export default {
  validationMessages: {
    note_play_to_early: 'Played too early',
    note_play_to_late: 'Played too late',
    note_missed: 'Missed note',
    wrong_note: 'Wrong note',
    note_cut_to_early: 'Cut too early',
    note_cut_to_late: 'Cut too late'
  }
};